export default __webpack_public_path__ + "static/equilibre_avatar_manon_lenain-5362afb1d56107c7e13b8744f8bd1b75.png";